<template>
	<svg height="94.5" viewBox="0 0 182.5 94.5" width="182.5" xmlns="http://www.w3.org/2000/svg"><g><path d="m22.9 56 29.08-29.08.02.08 4.5-4.5h-3.8-1.8-27.3-1.8-1.5v1.5 1.7 26.5 2.7 3.7z"/><path d="m100.4 30.3 12.7-11.8-2.2-2.2-2.7-2.8-9.1-9.1-.64-.64-1.66-1.66s0 0 0 0l-2.1-2.1-2.1 2.1-1.6 1.6-9.8 9.8-62.1 62.1s0 .1-.1.1l-13.41 13.33-5.59 5.47h36.1l.42-.42c.21-.13.41-.28.58-.48z"/><path d="m169.8 33.8h12.7l-1-1-.2-.2-28.2-28.2-4.3-4.4-3.33 3.33-10.27 10.27-55.5 55.5-1.7 1.7-4.9 4.9-11.53 11.39-7.57 7.41h3.8 3.1 26 2.1 1.2l.9-.9.01-.01 5.19-5.19-.02.01 64.02-64.11z"/></g></svg>
</template>

<script>
	export default {
		name: "SMIcon"
	}
</script>